import cn from 'classnames'

import type { INetworkDebugRequest } from 'shared/lib/networkDebug'

import { getProgressPercent } from './lib'

import styles from './NetworkStatusChip.module.scss'

export const NetworkStatusChip = ({ request }: { request: INetworkDebugRequest }) => {
  if (request.state === 'pending') {
    const percent = getProgressPercent(request)

    return (
      <span className={cn(styles.chip, styles.pending)}>
        <i className={styles.dot} />
        {percent === null ? '…' : `${percent} %`}
      </span>
    )
  }

  return (
    <span className={cn(styles.chip, { [styles.error]: request.state === 'error' })}>
      <i className={styles.dot} />
      {request.status ?? (request.state === 'error' ? '—' : 200)}
    </span>
  )
}

NetworkStatusChip.displayName = 'NetworkStatusChip'
